import { getTotalPrice } from '@shared/lib/money';
import {
	GdsService_OrderAdditionalServiceGdsServiceMeal_Fragment,
	GdsServiceProductStatus,
	OrderAdditionalServiceGdsServiceServiceType,
	PassengerSelectedGdsServicesProductFragment
} from '@websky/graphql';
import { ServiceOptionItem } from '../../../ServiceSummary/types';
import { getActualProduct } from '../../../ServiceSummary/utils';

import { ALL_SEGMENTS_KEY } from '@shared/lib/flight';

export function mealOptionItemFactory({
	key,
	serviceId,
	travellerId,
	gdsServiceRfisc,
	direction,
	count,
	confirmedCount,
	gdsService,
	products,
	groupType = 'all',
	isLoading
}: {
	key: string;
	serviceId: string;
	travellerId: string;
	gdsServiceRfisc?: string;
	direction: string;
	count: number;
	confirmedCount: number;
	gdsService: GdsService_OrderAdditionalServiceGdsServiceMeal_Fragment;
	products?: PassengerSelectedGdsServicesProductFragment[];
	groupType?: 'booked' | 'confirmed' | 'all';
	isLoading?: boolean;
}): ServiceOptionItem {
	let actualCount = count;
	let actualProducts = products.filter(product => product.passengerId === travellerId);

	const included = groupType === 'confirmed' || count === confirmedCount;
	const isAllSegments = key === ALL_SEGMENTS_KEY;

	if (groupType === 'booked') {
		actualCount = count - confirmedCount;
		actualProducts = actualProducts.filter(product => product.status === GdsServiceProductStatus.Booked);
	} else if (groupType === 'confirmed') {
		actualCount = confirmedCount;
		actualProducts = actualProducts.filter(product => product.status === GdsServiceProductStatus.Ticketed);
	}

	return {
		id: serviceId,
		rfisc: gdsServiceRfisc,
		name: `${direction}, ${actualCount}x ${gdsService.name}`,
		segment: key,
		price: getTotalPrice(actualProducts, product => product.price),
		status: getActualProduct(actualProducts)?.status,
		deleteMeta: !included
			? {
					serviceId,
					passengerId: travellerId,
					segmentId: key,
					type: OrderAdditionalServiceGdsServiceServiceType.Meal,
					allSegments: isAllSegments
			  }
			: null,
		included,
		isLoading
	};
}
